import type { ReadonlyDeep } from 'type-fest';
import type { DataItem as DispatchDriverJobsCustomTableDataItem } from '@/components/customTables/DispatchDriverJobsCustomTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import * as oneTrackingJobHelpers from '@/helpers/trackingJob/oneTrackingJob';
import * as commonConstants from '@/constants/common';
import * as customerConstants from '@/constants/customer';

export function getTableItem(
  dispatchJob: ReadonlyDeep<openapi.DespatchJobsContentOpenapi[0]>,
): DispatchDriverJobsCustomTableDataItem {
  const { jobId, jobDate } =
    oneTrackingJobHelpers.getJobIdAndJobDate(dispatchJob);

  return {
    id: dispatchJob.id,
    jobId,
    jobDate,
    clientIcon:
      dispatchJob.customer.highlight &&
      customerConstants.highlightIcons[dispatchJob.customer.highlight],
    clientIconTooltip:
      dispatchJob.customer.highlight &&
      customerConstants.highlightTooltips[dispatchJob.customer.highlight],
    clientCode: dispatchJob.customer.code || commonConstants.EM_DASH,
    clientName: dispatchJob.customer.name || commonConstants.EM_DASH,
    from: dispatchJob.stops.at(0)?.suburb || commonConstants.EM_DASH,
    to: dispatchJob.stops.at(-1)?.suburb || commonConstants.EM_DASH,
    service: dispatchJob.service_code || commonConstants.EM_DASH,
    notes: commonConstants.EM_DASH, // TODO note of the current stop?
  };
}

export function getTableData(
  dispatchJobs: ReadonlyDeep<openapi.DespatchJobsContentOpenapi> | undefined,
): DispatchDriverJobsCustomTableDataItem[] {
  const _dispatchJobsTableData: DispatchDriverJobsCustomTableDataItem[] = [];
  if (!dispatchJobs?.length) {
    return _dispatchJobsTableData;
  }
  dispatchJobs.forEach(function (dispatchJob) {
    _dispatchJobsTableData.push(getTableItem(dispatchJob));
  });
  return _dispatchJobsTableData;
}
